function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { ThemedInput as Input } from "./Input";
export { Textarea } from "@chakra-ui/react";
const baseStyle = _object_spread_props(_object_spread({}, Input.baseStyle.field), {
    paddingY: '8px',
    minHeight: '80px',
    lineHeight: 'short',
    verticalAlign: 'top'
});
var _Input_variants_solid;
const variants = {
    solid: (_Input_variants_solid = Input.variants.solid) !== null && _Input_variants_solid !== void 0 ? _Input_variants_solid : {}
};
var _Input_sizes_small_field, _Input_sizes_medium_field;
const sizes = {
    small: (_Input_sizes_small_field = Input.sizes.small.field) !== null && _Input_sizes_small_field !== void 0 ? _Input_sizes_small_field : {},
    medium: (_Input_sizes_medium_field = Input.sizes.medium.field) !== null && _Input_sizes_medium_field !== void 0 ? _Input_sizes_medium_field : {}
};
const defaultProps = {
    size: 'medium',
    variant: 'solid'
};
export const ThemedTextarea = {
    baseStyle,
    sizes,
    variants,
    defaultProps
};

//# sourceMappingURL=Textarea.js.map